export default __webpack_public_path__ + "static/media/publication_girl.db3aa9d5.png";